import _ from 'lodash'

import { DEFAULT_CARDS_PER_PAGE } from '../../configuration/tripsCards'

import {
  FETCH_CONFIG_BEGIN,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_ERROR
} from '../actions/fetchConfiguration'

const initialState = {
  loading: false,
  error: null,
  data: null
}

export default function fetchConfiguration(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONFIG_BEGIN:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_CONFIG_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload
      })
    case FETCH_CONFIG_ERROR:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload
      })
    default:
      return state
  }
}

export const configurationData = state => state.configurationData

export const getBrand = state => _.get(state, 'configurationData.data.brand')

export const getCardsPerPage = state => {
  const cardsPerPage = parseInt(_.get(state, 'configurationData.data.cardsPerPage'), 10)
  return cardsPerPage || DEFAULT_CARDS_PER_PAGE
}
